import { useEffect, useState } from "react";
import Input, { InputProps } from "./Input";
import { makeValueOnSchema } from "./Utils";
import { toast } from "react-toastify";

export default function ArrayInput(props: InputProps) {

    const [counter, setCounter] = useState(props.required ? 1: 0);

    const [values, setValues] = useState<any[]>(props.value ? props.value.map((val: any, index: number) => ({id: index, value: val})) : (props.required ? [{
        value: makeValueOnSchema(props.content.items),
        id: 0,
    }]: []));

    useEffect(() => {
        if(values.length > 0) {
            props.onChange(values.map(value => value.value))
        }
    }, [values])

    // todo: css :(
    return <div>
        <p>{props.content.title}</p>
        <input type="button" className=" btn-form" onClick={() => {
            setCounter((c) => {
                setValues([...values, {
                    value: makeValueOnSchema(props.content.items),
                    id: c,
                }])
                return c + 1
            })
        }} value='Add'></input>
        {values.map((val, index) => {
            return <div key={val.id}>
                <Input fromArray hasParent content={props.content.items} required={props.required} value={val.value} onChange={(val: any) => {
                    setValues((old) => {
                        old[index].value = val
                        return [...old]
                    })
                }}></Input>
                <input type="button" className=" btn-form" onClick={() => {
                    setValues((o) => {
                        if(props.required && o.length === 1) {
                            // needs at least one entry
                            toast.error("Cannot delete last entry in " + props.content.title, { theme: "colored" });
                        } else { 
                            o.splice(index, 1)
                        }
                        return [...o];
                    })
                }} value='Remove'></input>
            </div>
        })}
    </div>
}